import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import Reveal from '../components/Reveal';
import ClayIcon from '../components/site/ClayIcon';
import './Services.css';

const ICONS = ['car', 'plane', 'clock', 'diamond', 'briefcase', 'moon'];

function Services() {
    const { t } = useTranslation();
    const services = t('services.items', { returnObjects: true });
    const steps = t('services.howItWorks.steps', { returnObjects: true });

    return (
        <div className="services-page">
            {/* Header */}
            <section className="services-header hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/two-taxis-hotel-banner.jpg)' }}>
                <div className="container">
                    <h1>{t('services.header.title')}</h1>
                    <p>{t('services.header.subtitle')}</p>
                </div>
            </section>

            {/* Services Grid */}
            <section className="services-section">
                <div className="container">
                    <ul className="services-grid">
                        {services.map((service, index) => (
                            <Reveal as="li" key={service.title} className="service-card card-lift" delay={(index % 3) * 60}>
                                <ClayIcon name={ICONS[index]} size={64} />
                                <h2>{service.title}</h2>
                                <p className="service-description">{service.description}</p>
                                <ul className="service-features">
                                    {service.features.map((feature) => (
                                        <li key={feature} className="feature-tag">
                                            <Check size={16} className="feature-check" aria-hidden="true" /> {feature}
                                        </li>
                                    ))}
                                </ul>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </section>

            {/* How It Works */}
            <section className="how-it-works">
                <div className="container">
                    <h2 className="section-heading">{t('services.howItWorks.title')}</h2>
                    <div className="steps-grid">
                        {steps.map((step, index) => (
                            <Reveal key={index} className="step" delay={index * 60}>
                                <div className="step-indicator">{index + 1}</div>
                                <h3>{step.title}</h3>
                                <p>{step.desc}</p>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="services-cta hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/fleet-three-taxis-banner.jpg)' }}>
                <div className="container">
                    <h2>{t('services.cta.title')}</h2>
                    <p>{t('services.cta.subtitle')}</p>
                    <Link to="/#book" className="btn btn-primary btn-large">{t('services.cta.bookNow')}</Link>
                </div>
            </section>
        </div>
    );
}

export default Services;